import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-961ea0c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "pages-wrapper",
  id: "pages-wrapper"
}
const _hoisted_2 = { class: "pages" }
const _hoisted_3 = { class: "catalog" }
const _hoisted_4 = { class: "level catalog-wrapper" }
const _hoisted_5 = {
  key: 1,
  class: "lock-wrap"
}
const _hoisted_6 = {
  key: 2,
  class: "lock-wrap"
}

import {onBeforeMount, ref, onMounted} from "vue";
import {fetchRecordedContent, RecordedContentVO} from "@/apis/recorded";
import {CoursePlanPartVO} from "@/apis/course";
import {ArrowRightBold} from '@element-plus/icons'
import MainRecordedCatalogItem from "@/pages/Main/components/MainRecordedCatalogItem.vue";
import MainRecordedContentItem from "@/pages/Main/components/MainRecordedContentItem.vue";
import exposure from "@/composables/exposure";


export default /*#__PURE__*/_defineComponent({
  __name: 'MainRecorded',
  props: {
    part: {}
  },
  setup(__props: any) {

const props = __props

const isUnlockProp = ref<boolean>(false)
const noContent = ref<boolean>(false)
const content = ref<RecordedContentVO[]>()
const getRecordedContent = async (courseId: number, partId: number) => {
  const data = await fetchRecordedContent(courseId, partId)
  if(data?.code === 200){
    content.value = data?.data
    // 当菜单内容为一条时 折叠菜单
    if(content.value?.length > 1){
      showCatalog.value = true
    }
  } else if(data?.code === 20002){
    // 未到开课时间
    isUnlockProp.value = true
  } else if(data?.code === 20004) {
    // 未更新
    noContent.value = true
  }

}

const showCatalog = ref<boolean>(false)

const currentId = ref<string>()

// eslint-disable-next-line no-undef
const calcCurrent = (scrollTop: number, titleDoms: NodeListOf<HTMLElement>) => {
  let titleIds: string[] = []
  let titleOffsetTops: number[] = []
  titleDoms.forEach((dom: HTMLElement) => {
    titleIds.push(dom.id);
    titleOffsetTops.push(dom.offsetTop);
  })
  titleIds = titleIds.reverse();
  titleOffsetTops = titleOffsetTops.reverse();
  for (let i = 0; i < titleOffsetTops.length; i++) {
    if (scrollTop >= titleOffsetTops[i]) {
      currentId.value = titleIds[i]
      break;
    }
  }
}
/**
 * 防抖
 * @param fn
 * @param wait
 */
const debounce = (fn: () => void, wait: number) => {
  let timeout: number | null = null;
  return function () {
    if (timeout !== null) window.clearTimeout(timeout);
    timeout = window.setTimeout(fn, wait);
  }
}

onBeforeMount(() => {
  getRecordedContent(props.part.userCoursePlanPart.courseId, props.part.id).then(() => {
    const recordedArea = document.querySelector('#pages-wrapper');
    if (recordedArea) {
      recordedArea.addEventListener('scroll',
        debounce(() => calcCurrent(recordedArea.scrollTop, document.querySelectorAll<HTMLElement>('.content-title')), 200)
      );
      // 初始状态触发
      calcCurrent(recordedArea.scrollTop, document.querySelectorAll<HTMLElement>('.content-title'));
    }
  })
})
const {addExposureMonitor} = exposure()
onMounted(() => {
  //添加元素曝光监控
  setTimeout(() => {
    document.querySelectorAll('.exposure').forEach(ele => addExposureMonitor(ele))
  }, 1000)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (content.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["recorded", showCatalog.value? 'catalog-show': 'catalog-hide'])
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(content.value, (item) => {
                return (_openBlock(), _createBlock(MainRecordedContentItem, {
                  content: item,
                  level: 1,
                  part: _ctx.part,
                  key: 'content' + item.id
                }, null, 8, ["content", "part"]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: _normalizeClass(["trigger-btn", !showCatalog.value && 'reverse']),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (showCatalog.value = !showCatalog.value))
            }, [
              _createVNode(_unref(ArrowRightBold), { class: "icon" })
            ], 2),
            _withDirectives(_createElementVNode("ul", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(content.value, (item) => {
                return (_openBlock(), _createBlock(MainRecordedCatalogItem, {
                  content: item,
                  key: 'catalog' + item.id,
                  part: _ctx.part,
                  currentId: currentId.value
                }, null, 8, ["content", "part", "currentId"]))
              }), 128))
            ], 512), [
              [_vShow, showCatalog.value]
            ])
          ])
        ], 2))
      : _createCommentVNode("", true),
    (isUnlockProp.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, " 暂未开课, 开课时间为" + _toDisplayString(_ctx.part.userCoursePlanPart.unlockProp), 1))
      : _createCommentVNode("", true),
    (noContent.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, " 暂未更新，敬请期待 "))
      : _createCommentVNode("", true)
  ], 64))
}
}

})